import React from 'react';
import type { City, LocalType, POI, SourceRef } from './types';
import { GUIDES } from './data/guides';

// ============================================================================
// ICONE
// ============================================================================

export const RestaurantIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M11 9H9V2H7V9H5V2H3V9C3 11.12 4.66 12.84 6.75 12.97V22H9.25V12.97C11.34 12.84 13 11.12 13 9V2H11V9ZM16 6V14H18.5V22H21V2C18.24 2 16 4.24 16 6Z" /></svg>
);

export const OneStarRestaurantIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 512 512" fill="none" aria-hidden="true">
        <circle cx="256" cy="256" r="256" fill="#F38C1E"/>
        <path d="M421.2 165.6c-20.6-58.1-70.1-105.4-128.5-125.7l128.5 125.7z" fill="#D37410" opacity=".2"/>
        <path d="M106.3 69.5v116.3c0 30.8 13.9 58.3 35.8 77v179.6h60.9V262.8c21.9-18.7 35.8-46.2 35.8-77V69.5H211V181h-21.3V69.5h-27.9V181h-21.3V69.5h-34.2z" fill="#E8F1F8"/>
        <path d="M299.7 186.2V41.7c-40.1 8.5-80.1 63-80.1 144.5 0 30.8 13.9 58.3 35.8 77v179.6h44.3V186.2z" fill="#000" opacity=".05"/>
        <path d="M309.4 442.8V253.1c-13-17.4-20.6-38.9-20.6-62.1 0-77.9 33.6-141.1 75-141.1V442.8h-54.4z" fill="#000" opacity=".05"/>
        <path d="M309.4 69.5c0-15.4 34-15.4 34 0v183.6c0 30.8-13.9 58.3-35.8 77v112.7h60.9V330.1c21.9-18.7 35.8-46.2 35.8-77V69.5c0-30.8-13.9-58.3-35.8-77C324.9 22.8 309.4 48.7 309.4 69.5z" fill="#E8F1F8"/>
        <rect x="106.3" y="253.1" width="132.5" height="42.8" rx="4" fill="#FFD24D"/>
        <rect x="309.4" y="253.1" width="96.7" height="42.8" rx="4" fill="#FFD24D"/>
        <path d="M106.3 295.9v112.7c0 18.9 15.3 34.2 34.2 34.2h64.1c18.9 0 34.2-15.3 34.2-34.2V295.9h-132.5z" fill="#5F4F47"/>
        <path d="M309.4 295.9v112.7c0 18.9 11.2 34.2 24.9 34.2h46.9c13.8 0 24.9-15.3 24.9-34.2V295.9h-96.7z" fill="#5F4F47"/>
    </svg>
);

export const GelatoIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 512 512" fill="none" aria-hidden="true">
        <ellipse cx="256" cy="480" rx="100" ry="20" fill="#000" opacity="0.1" />
        <path d="M165 235 L256 500 L347 235 Z" fill="#F39C12" />
        <path d="M165 235 L256 500 L256 235 Z" fill="#FFCC00" />
        <path d="M160 250 C160 210 352 210 352 250 L347 235 L165 235 Z" fill="#000" opacity="0.05" />
        <path d="M128 200 C128 100 384 100 384 200 C384 245 350 250 330 250 L182 250 C162 250 128 245 128 200 Z" fill="#F06292" />
        <circle cx="160" cy="220" r="45" fill="#F06292" />
        <circle cx="210" cy="235" r="45" fill="#F06292" />
        <circle cx="270" cy="235" r="45" fill="#F06292" />
        <circle cx="330" cy="230" r="45" fill="#F06292" />
        <circle cx="365" cy="210" r="40" fill="#F06292" />
        <path d="M250 235 C250 300 305 300 305 235 Z" fill="#F06292" />
        <path d="M180 160 C180 120 240 100 280 110" stroke="#FFF" strokeWidth="15" strokeLinecap="round" opacity="0.2" />
    </svg>
);

export const CafeIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M2,21H20V19H2M20,8H18V5H20M20,3H4V13A4,4 0 0,0 8,17H14A4,4 0 0,0 18,13V10H20A2,2 0 0,0 22,8V5C22,3.89 21.1,3 20,3Z" /></svg>
);

export const BarIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21,9L17,5H7L3,9H21M9,10L10.5,12H13.5L15,10H9M7.4,14L9,22H15L16.6,14H7.4Z" /></svg>
);

export const PizzaSliceIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 512 512" fill="none" aria-hidden="true">
        <path d="M465.1 364.6c-18.7 132-230.1 166-419.6 132-23.3-4.2-40.8-11.8-40.8-21.7 0-11.1 21.9-20.1 52.8-26.1l407.6-84.2z" fill="#D37410" opacity=".2"/>
        <path d="M125.7 30.5c-15.4-15.4 15.4-30.8 46.2-30.5 128.5 1.4 308.2 82.2 338.4 442.8 5.6 67.2-50.4 61.6-67.2 44.8L125.7 30.5z" fill="#E6914D"/>
        <path d="M141.1 54.4c132.3 8.5 292 63.3 314 366.5-12.7 12.7-25.4 25.4-38.1 38.1L141.1 54.4z" fill="#FFF2CC" opacity=".4"/>
        <path d="M417.4 421.2L16.2 467.5c-15.4 1.8-21-17.4-8.5-27L385.2 65.4c11.2-8.5 27.2-2.1 29.4 11.9l2.8 180.6 0z" fill="#FFD966"/>
        <path d="M417.4 421.2L16.2 467.5l369-346.3 32.2 300z" fill="#FFD24D"/>
        <circle cx="180.5" cy="385.2" r="48.1" fill="#E02A5D"/>
        <circle cx="340.4" cy="180.5" r="48.1" fill="#E02A5D"/>
        <circle cx="612.4" cy="733.2" r="48.1" fill="#E02A5D" transform="translate(-100,-350)"/>
        <path d="M245.5 320.3c15.4 15.4 15.4 41 0 56.4s-41 15.4-56.4 0 15.4-41 0-56.4 41-15.4 56.4 0z" fill="#71C052" transform="translate(40,-40)"/>
        <path d="M96.7 417.4c11.2 11.2 11.2 29.4 0 40.6s-29.4 11.2-40.6 0 11.2-29.4 0-40.6 29.4-11.2 40.6 0z" fill="#71C052"/>
        <rect x="280" y="240" width="30" height="8" rx="4" fill="#FFF2CC" opacity=".6" transform="rotate(-35, 280, 240)"/>
        <rect x="130" y="490" width="20" height="6" rx="3" fill="#FFF2CC" opacity=".6" transform="rotate(-15, 130, 490)"/>
    </svg>
);

export const SushiIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 512 512" fill="none" aria-hidden="true">
        <path d="M30 180c0 50 45 90 100 90s100-40 100-90V80c0-50-45-90-100-90S30 30 30 80v100z" fill="#434D5E"/>
        <ellipse cx="130" cy="80" rx="100" ry="90" fill="#E6E9EE"/>
        <ellipse cx="130" cy="80" rx="55" ry="45" fill="#F39C12"/>
        <path d="M130 35c40 0 60 20 60 45s-20 45-60 45c-20 0-40-10-50-25l50-20z" fill="#88D498" opacity="0.6"/>
        <path d="M120 400c0 50 45 90 100 90s100-40 100-90V300c0-50-45-90-100-90s-100 40-100 90v100z" fill="#434D5E"/>
        <ellipse cx="220" cy="300" rx="100" ry="90" fill="#E6E9EE"/>
        <ellipse cx="220" cy="300" rx="55" ry="45" fill="#D3546D"/>
        <path d="M220 255c40 0 60 20 60 45s-20 45-60 45c-20 0-40-10-50-25l50-20z" fill="#88D498" opacity="0.6"/>
        <path d="M470 40L60 380c-5 5-5 15 0 20s15 5 20 0L490 60c5-5 5-15 0-20s-15-5-20 0z" fill="#E9C46A"/>
        <path d="M470 300L60 450c-5 3-5 10 0 13s15 3 20 0L490 313c5-3 5-10 0-13s-15-3-20 0z" fill="#E9C46A" opacity="0.9"/>
    </svg>
);

export const PasticceriaIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22,14C22,15.11 21.1,16 20,16H4C2.9,16 2,15.11 2,14V12C2,10.9 2.9,10 4,10H5V6C5,4.9 5.9,4 7,4H17C18.1,4 19,4.9 19,6V10H20C21.1,10 22,10.9 22,12V14M17,8H7V6H17V8M2,18C2,19.1 2.9,20 4,20H20C21.1,20 22,19.1 22,18V17H2V18Z" /></svg>
);

export const StreetFoodIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18,10H15V8H18M18,13H15V11H18M18,16H15V14H18M20.84,10.22L20,22H4V3H14.11L15.15,4.83L16.2,4L17.5,6L16.45,6.83L17.39,8.22L19,8V10C19.5,10 19.9,10.08 20.22,10.22M13,3.5H5V20.5H18.5L19.2,10.15C18.84,10.06 18.44,10 18,10V7.33L16.09,4.4L15.05,5.22L14.27,3.9L13,3.5Z" /></svg>
);

export const SnailIcon: React.FC<{className?: string}> = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 512 512" fill="none" aria-hidden="true">
        <circle cx="430" cy="80" r="24" fill="#FEE1A1"/>
        <line x1="430" y1="80" x2="420" y2="160" stroke="#FEE1A1" strokeWidth="12" strokeLinecap="round"/>
        <circle cx="490" cy="70" r="24" fill="#FEE1A1"/>
        <line x1="490" y1="70" x2="470" y2="150" stroke="#FEE1A1" strokeWidth="12" strokeLinecap="round"/>
        <path d="M20 460c0-30 60-70 150-70 100 0 250 50 250 180 0 40-50 40-100 40H60c-40 0-40-110-40-150z" fill="#FEE1A1"/>
        <path d="M420 400c40-30 80-100 80-200 0-80-40-130-90-130s-90 50-90 130c0 40 10 70 30 100l70 100z" fill="#FEE1A1"/>
        <circle cx="210" cy="300" r="190" fill="#A67C52"/>
        <path d="M210 300c-20 0-40-15-40-40s20-40 50-40 60 25 60 60-35 80-80 80-100-45-100-110 55-140 130-140 160 75 160 180-85 220-190 220" stroke="#8B6040" strokeWidth="18" strokeLinecap="round" fill="none" opacity="0.6"/>
        <path d="M420 570c0 0-20-40-40-40h100c0 0-20 40-60 40z" fill="#000" opacity="0.05"/>
    </svg>
);

// ============================================================================
// STILI MARKER
// ============================================================================

type Style = {
  /** Icona renderizzata dentro al pin (componente React). */
  icon: React.FC<{className?: string}>;
  /** Classe Tailwind per il colore del cerchio (es. "bg-yellow-400"). */
  color: string;
  /** Colore del triangolino del pin in formato hex. */
  pinColor: string;
};

/**
 * Stile di base per ogni tipo di locale.
 * Determina l'ICONA del marker (sempre) e il colore di fallback
 * quando il POI non ha un tier riconoscibile.
 */
export const TYPE_STYLES: Record<LocalType, Style> = {
  ristorante:    { icon: RestaurantIcon,       color: 'bg-yellow-500',  pinColor: '#eab308' },
  pizzeria:      { icon: PizzaSliceIcon,       color: 'bg-red-500',     pinColor: '#ef4444' },
  gelateria:     { icon: GelatoIcon,           color: 'bg-pink-500',    pinColor: '#ec4899' },
  pasticceria:   { icon: PasticceriaIcon,      color: 'bg-fuchsia-500', pinColor: '#d946ef' },
  caffe:         { icon: CafeIcon,             color: 'bg-amber-600',   pinColor: '#d97706' },
  bar:           { icon: BarIcon,              color: 'bg-purple-500',  pinColor: '#a855f7' },
  osteria:       { icon: SnailIcon,            color: 'bg-orange-900',  pinColor: '#7c2d12' },
  sushi:         { icon: SushiIcon,            color: 'bg-cyan-700',    pinColor: '#0e7490' },
  "street-food": { icon: StreetFoodIcon,       color: 'bg-teal-500',    pinColor: '#14b8a6' },
};

export const TYPE_LABELS: Record<LocalType, string> = {
  ristorante:    "Ristorante",
  pizzeria:      "Pizzeria",
  gelateria:     "Gelateria",
  pasticceria:   "Pasticceria",
  caffe:         "Caffè",
  bar:           "Bar",
  osteria:       "Osteria",
  sushi:         "Sushi",
  "street-food": "Street Food",
};

/**
 * Override del COLORE del marker per tier specifici.
 * Le chiavi hanno la forma "guideId|tier".
 * Quando un POI ha sources[], si prende quella di rank piu' alto e si
 * verifica se la sua coppia (guideId, tier) e' qui dentro.
 */
const TIER_COLOR_OVERRIDES: Record<string, { color: string; pinColor: string }> = {
  "michelin|3-stars":              { color: 'bg-yellow-400',  pinColor: '#facc15' },
  "michelin|2-stars":              { color: 'bg-yellow-500',  pinColor: '#eab308' },
  "michelin|1-star":               { color: 'bg-orange-500',  pinColor: '#f97316' },
  "gambero-rosso-pizzerie|3-spicchi":   { color: 'bg-red-500',     pinColor: '#ef4444' },
  "gambero-rosso-pizzerie|3-rotelle":   { color: 'bg-orange-500',  pinColor: '#f97316' },
  "gambero-rosso-gelaterie|3-coni":     { color: 'bg-pink-500',    pinColor: '#ec4899' },
  "gambero-rosso-sushi|3-bacchette":    { color: 'bg-cyan-700',    pinColor: '#0e7490' },
  "gambero-rosso-caffe|3-chicchi":      { color: 'bg-amber-600',   pinColor: '#d97706' },
  "gambero-rosso-pasticcerie|3-torte":  { color: 'bg-fuchsia-500', pinColor: '#d946ef' },
  "slow-food-osterie|chiocciola":       { color: 'bg-orange-900',  pinColor: '#7c2d12' },
};

/** Recupera il rank numerico di una source guardando il registro guide. */
export function getSourceRank(source: SourceRef): number {
  if (!source.tier) return 0;
  const guide = GUIDES[source.guideId];
  return guide?.tiers?.find(t => t.id === source.tier)?.rank ?? 0;
}

/** Ritorna le sources ordinate per rank decrescente (la migliore prima). */
export function sortSourcesByRank(sources: SourceRef[]): SourceRef[] {
  return [...sources].sort((a, b) => getSourceRank(b) - getSourceRank(a));
}

/** Ritorna l'etichetta umana di un tier (es. "3 Stelle") oppure null. */
export function getTierLabel(source: SourceRef): string | null {
  if (!source.tier) return null;
  const guide = GUIDES[source.guideId];
  return guide?.tiers?.find(t => t.id === source.tier)?.label ?? null;
}

/**
 * Calcola lo stile finale del marker per un POI.
 * - L'icona viene sempre dal tipo del locale.
 * - Il colore viene dall'override di tier piu' prestigioso, se esiste,
 *   altrimenti dal colore di default del tipo.
 */
export function getMarkerStyle(poi: POI): Style {
  const typeStyle = TYPE_STYLES[poi.type];
  if (poi.sources.length > 0) {
    const top = sortSourcesByRank(poi.sources)[0];
    if (top.tier) {
      const key = `${top.guideId}|${top.tier}`;
      const override = TIER_COLOR_OVERRIDES[key];
      if (override) {
        return { icon: typeStyle.icon, color: override.color, pinColor: override.pinColor };
      }
    }
  }
  return typeStyle;
}

/**
 * URL Google Maps che apre direttamente la pagina del locale (scheda con
 * foto, recensioni, orari), non un pin sulle coordinate.
 *
 * Strategia: la Google Maps URL API ("/maps/search/?api=1") fa la ricerca
 * per testo e, quando ottiene un match univoco, apre direttamente la card
 * del business. "Trippa Milano" → scheda di Trippa, non lista generica.
 *
 * Per disambiguare omonimi (es. "La Madia" esiste a Brione e Licata) si
 * include la citta'. La provincia (sigla) viene aggiunta SOLO se la citta'
 * e' molto piccola/frazione, per evitare false collisioni con omonime.
 *
 * Le coordinate non sono incluse nella query (Google le interpreterebbe
 * come ricerca per coords, perdendo il match al business) ma vanno in
 * `center=...` come bias geografico (parametro non documentato ma
 * supportato).
 */
export function getGoogleMapsUrl(poi: POI): string {
  const parts = [poi.name];
  if (poi.city) parts.push(poi.city);
  if (poi.province) parts.push(poi.province);
  const query = parts.filter(Boolean).join(" ").trim();

  if (query) {
    const q = encodeURIComponent(query);
    const center = `${poi.coordinates.lat},${poi.coordinates.lng}`;
    return `https://www.google.com/maps/search/?api=1&query=${q}&center=${center}`;
  }
  // Fallback: pin sulle coordinate (raro: tutti i POI dovrebbero avere name)
  const coords = encodeURIComponent(`${poi.coordinates.lat},${poi.coordinates.lng}`);
  return `https://www.google.com/maps/search/?api=1&query=${coords}`;
}

/** URL della pagina della guida per una source: pageUrl se c'e', altrimenti homepage. */
export function getSourceUrl(source: SourceRef): string {
  return source.pageUrl ?? GUIDES[source.guideId]?.homepage ?? "#";
}

// ============================================================================
// CITTA' / VISTA INIZIALE
// ============================================================================

export const ITALY_VIEW = {
    coordinates: { lat: 41.8719, lng: 12.5674 },
    zoom: 6
};

export const CITIES: City[] = [
    { name: "Rome", coordinates: { lat: 41.9028, lng: 12.4964 }, zoom: 12 },
    { name: "Milan", coordinates: { lat: 45.4642, lng: 9.1900 }, zoom: 12 },
    { name: "Naples", coordinates: { lat: 40.8518, lng: 14.2681 }, zoom: 12 },
    { name: "Turin", coordinates: { lat: 45.0703, lng: 7.6869 }, zoom: 12 },
    { name: "Palermo", coordinates: { lat: 38.1157, lng: 13.3615 }, zoom: 12 },
    { name: "Genoa", coordinates: { lat: 44.4056, lng: 8.9463 }, zoom: 12 },
    { name: "Bologna", coordinates: { lat: 44.4949, lng: 11.3426 }, zoom: 12 },
    { name: "Florence", coordinates: { lat: 43.7696, lng: 11.2558 }, zoom: 12 },
    { name: "Bari", coordinates: { lat: 41.1171, lng: 16.8719 }, zoom: 12 },
    { name: "Catania", coordinates: { lat: 37.5079, lng: 15.0830 }, zoom: 12 },
    { name: "Venice", coordinates: { lat: 45.4408, lng: 12.3155 }, zoom: 12 },
    { name: "Verona", coordinates: { lat: 45.4384, lng: 10.9916 }, zoom: 12 },
];
